import pkg from './package.json';

export const version = pkg.version;

export * from './src/index.es';



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client/packages/primitive-utilities/index.es